module.exports = __webpack_public_path__ + "static/media/newScan.034c4601.svg";